import moment from "moment";
import React from "react";
import ReactHtmlParser from "react-html-parser";

const ReleaseNotesSection = ({ releaseNote }) => {
  if (!releaseNote) return null;
  const { releaseDate, version, title, summary, details, customHTML } = releaseNote;
  const dateFormat = "dddd, Do MMMM YYYY";
  const dateString = moment(releaseDate).format(dateFormat);
  return (
    <div>
      <h2>{title}</h2>
      <p>
        {dateString} | Version {version}
      </p>
      <hr />
      <p>{summary}</p>
      {customHTML?.length > 0 ? (<div>{ReactHtmlParser(customHTML)}</div>) : null}
      {details.map((detail) => {
        return <p> - {detail}</p>;
      })}
    </div>
  );
};

export default ReleaseNotesSection;
